import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import ExternalLink from "../components/ExternalLink";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`About🖊`}</h2>
    <h5>{`I am a Frontend Developer from Jamshedpur, India interested to create the best and accessible web applications with enhanced user experience.`}</h5>
    <p>{`I've also had experience working with `}<strong parentName="p">{`React, MySQL, PostgreSQL, NodeJs, Express, MongoDB.`}</strong><br parentName="p"></br>{`
`}<em parentName="p">{`Exploring and being Adaptive on the go.`}</em></p>
    <p>{`I've got projects in all the different technologies that I explore. I'd love you to checkout my projects in the `}<em parentName="p">{`projects`}</em>{` section.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      